import FaqCreative from "@/assets/images/FAQ.svg";
import AccordionGroup from "@/components/molecules/AccordianGroup";
import CtaButtonGroup, { CtaType } from "../molecules/CtaButtonGroup";

import Image from "next/image";
import Heading from "../atoms/Heading";

export type FaqSectionPropsType = {
  title: string;
  description: string;
  cta: CtaType;
  faqs: {
    question: string;
    answer: string;
  }[];
  showCTA?: boolean;
};

const FaqSection = (props: FaqSectionPropsType) => {
  const { title, description, cta, faqs, showCTA=true } = props;

  return (
    <div className="colu container mx-auto flex  flex-col gap-6 sm:flex-row sm:gap-10">
      <div className="flex flex-grow-0 flex-col items-start sm:flex-shrink-0 sm:basis-64 md:basis-80 lg:basis-96">
        <Heading
          heading={[{ text: title }]}
          fontStyle="text-title-20 sm:text-title-32"
          as="h3"
        />
        <p className="mb-4 mt-1 text-body-14 text-grey-3">{description}</p>
        {showCTA && (<div>
            <CtaButtonGroup ctas={[cta]} fullWidthOnMobile={false} />
          </div>)}
        <div className="mt-10 hidden h-52 self-stretch sm:block">
          <Image src={FaqCreative} alt="" />
        </div>
      </div>
      <AccordionGroup
        data={faqs.map((faq, index) => ({
          id: index,
          title: faq.question,
          body: faq.answer,
        }))}
      />
    </div>
  );
};

export default FaqSection;
